import { createFileRoute } from '@tanstack/react-router'
import { DocumentViewerPage } from '@/features/document-viewer/ui/DocumentViewerPage'
import { parseRouteId } from '@/features/document-viewer/lib/parseRouteId'

export const Route = createFileRoute('/documents/invoice/$clientId/$invoiceId')({
  component: InvoiceDocumentRoute,
  staticData: { authorize: false },
})

function InvoiceDocumentRoute() {
  const { clientId, invoiceId } = Route.useParams()
  return <DocumentViewerPage kind="invoice" clientId={parseRouteId(clientId)} documentId={parseRouteId(invoiceId)} />
}
